import Modal from 'react-modal'
import './login-modal.css';
import agent from '../agent';
import React from 'react';
import SGIDConfirmationModal from './SGIDConfirmationModal.js';
import { BACKEND_URL } from '../constants/constants';


class SGIDSelectionModal extends React.Component {
  constructor(props) {
    super(props)
    const names = props.currentUser.fullName ? props.currentUser.fullName.split(' ') : []
    const firstnames = {}
    for (const name of names) {
      firstnames[name] = false
    }
    this.state = {
      showLoginPrompt: props.isOpen,
      names,
      surname: undefined,
      firstnames,
    }
  }

  openLoginPrompt = () => {
    this.setState({ showLoginPrompt: true });
  }

  closeLoginPrompt = () => {
    this.setState({ showLoginPrompt: false });
  }

  openLoginModal = (event) => {
    // if (event) event.preventDefault()
    // this.closeLoginPrompt()
    // let container = this.props.container
    // container.openLoginModal()
  }

  chooseSurname = (event, name) => {
    if (event) event.preventDefault()
    this.setState({ surname: name });
    // reset first name selection
    const firstnames = { ...this.state.firstnames }
    Object.keys(firstnames).forEach(name => {
      firstnames[name] = false
    })
    this.setState({ firstnames })
    this.forceUpdate() 
  }

  getSurnameStyling = (name) => {
    if (name === this.state.surname) {
      return {
        background: '#494CA2',
        color: '#FFFFFF',
        fontWeight: 'bold'
      }
    } else {
      return {
        background: 'rgba(196, 196, 196, 0.2)',
        color: 'rgba(66, 66, 66, 0.3)',
        fontWeight: 'normal'
      }
    }
  }

  getFirstnameStyling = (name) => {
    if (this.state.firstnames[name]) {
      return {
        background: '#494CA2',
        color: '#FFFFFF',
        fontWeight: 'bold'
      }
    } else {
      return {
        background: 'rgba(196, 196, 196, 0.2)',
        color: 'rgba(66, 66, 66, 0.3)',
        fontWeight: 'normal'
      }
    }
  }

  getFirstnameOptions = () => {
    let options = [...this.state.names]
    let index = this.state.names.indexOf(this.state.surname)
    options.splice(index, 1)
    return options
  }

  chooseFirstname = (event, name) => {
    if (event) event.preventDefault()
    const firstnames = { ...this.state.firstnames, [name]: !this.state.firstnames[name] }
    this.setState({ firstnames })
  }

  isFirstnameChosen = () => {
    let isChosen = false
    Object.keys(this.state.firstnames).forEach(name => {
      isChosen = isChosen || this.state.firstnames[name]
    })
    return isChosen
  }

  getPreferredName = () => {
    let preferredName = []
    this.state.names.forEach(name => {
      if (this.state.firstnames[name]) {
        preferredName.push(name)
      }
    })
    let initial = this.state.surname && this.state.surname.charAt(0)
    preferredName.push(initial + '.')
    return preferredName.join(' ')
  }

  resetSelection = (event) => {
    if (event) event.preventDefault()
    this.setState({ surname: undefined })
    const firstnames = { ...this.state.firstnames }
    for (const name of this.state.names) {
      firstnames[name] = false
    }
    this.setState({ firstnames })
  }

  confirmSelection = (event) => {
    if (event) event.preventDefault()
    this.closeLoginPrompt()
    this.refs.SGIDConfirmationModal.openLoginPrompt(this.props.currentUser.fullName, this.getPreferredName(), this.props.currentUser.sex)
  }

  render() {

    const redirectEndpoint = `${BACKEND_URL}/redirect?state=${this.state.handle}`

    return (
      <div>
        <Modal
          isOpen={this.state.showLoginPrompt}
          onRequestClose={this.closeLoginPrompt}
          className="Modal"
          overlayClassName="Overlay">
          <div className="title">Choose your display name</div>
          <div className="step">1. Surname (Select one)</div>
          <div className="surname">
            {
              this.state.names.map((name) => {
                return (
                  <div className="choices" onClick={((e) => this.chooseSurname(e, name))} style={ this.getSurnameStyling(name) }>{ name }</div>
                );
              })
            }
          </div>
          <div style={ this.state.surname !== undefined ? { visibility: 'visible' } : { visibility: 'hidden' } }>
            <div className="step">2. Given name (Select names to display)</div>
            <div className="firstname"> {
                this.getFirstnameOptions().map((name) => {
                  return (
                    <div className="choices" onClick={((e) => this.chooseFirstname(e, name))} style={ this.getFirstnameStyling(name) }>{ name }</div>
                  );
                })
              }
            </div>
          </div>
          <div style={ this.isFirstnameChosen() ? { visibility: 'visible' } : { visibility: 'hidden' } }>
            <div className="summary">Your name will be displayed to other users as:</div>
            <div className="preferred-name"> { this.getPreferredName() }</div>
            <div className="btn-container">
              <div className="resetBtn" onClick={this.resetSelection}>
                Reset
              </div>
              <div className="confirmBtn" onClick={this.confirmSelection}>
                Confirm
              </div>
            </div>
          </div>
          <div className="cancel" onClick={this.openLoginModal}>Cancel</div>
        </Modal>
        <SGIDConfirmationModal container={this} ref="SGIDConfirmationModal"/>
      </div>
    );
  }
}

export default SGIDSelectionModal






// WEBPACK FOOTER //
// ./src/components/SGIDSelectionModal.js